export default __webpack_public_path__ + "static/media/VU.68c589d9.svg";